module.exports = __webpack_public_path__ + "static/media/EHS-Staff-Loans-and-Advances-Policy-and-Procedure.d82fa360.pdf";